import { render, staticRenderFns } from "./IconTypeformPictureChoice.vue?vue&type=template&id=836f7b14&"
import script from "./IconTypeformPictureChoice.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformPictureChoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports